import {useCallback} from 'react';

import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {
  useSelectedDiscount,
  useSelectedDiscountCallback,
} from '../SelectedDiscounts/useSelectedDiscount';
import {DiscountType} from '../enums/DiscountType';

const getCampaignKeyFromSelectedDiscount = ({
  discount,
}: GetDiscountsResponse_Discount) => {
  if (discount?.$case === 'priceReductionCampaign') {
    const {type: campaignType} = discount.priceReductionCampaign.campaign;
    switch (campaignType?.$case) {
      case 'minor':
        return campaignType.minor.campaignKey ?? null;
      case 'reduction':
        return campaignType.reduction.campaignKey ?? null;
      default:
        return null;
    }
  }

  if (discount?.$case === DiscountType.personalDiscount) {
    return discount.personalDiscount.legacyCampaignKey;
  }
  return null;
};

export const useCampaignKey = () => {
  const selectedDiscount = useSelectedDiscount();
  return selectedDiscount
    ? getCampaignKeyFromSelectedDiscount(selectedDiscount)
    : null;
};

export const useCampaignKeyCallback = () => {
  const selectedDiscountCallback = useSelectedDiscountCallback();
  return useCallback(async () => {
    const selectedDiscount = await selectedDiscountCallback();
    if (!selectedDiscount) {
      return null;
    }
    return getCampaignKeyFromSelectedDiscount(selectedDiscount);
  }, [selectedDiscountCallback]);
};
